import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, iconColor, trend }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation border border-border">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <h3 className="text-3xl font-bold text-foreground">{value}</h3>
        </div>
        <div className={`p-3 rounded-lg ${iconColor}`}>
          <Icon name={icon} size={24} color="currentColor" />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon name={getChangeIcon()} size={16} className={getChangeColor()} />
          <span className={`text-sm font-medium ${getChangeColor()}`}>{change}</span>
          <span className="text-sm text-muted-foreground">vs last month</span>
        </div>
        {trend && (
          <div className="flex items-center gap-1">
            {trend?.map((value, index) => (
              <div
                key={index}
                className="w-1 bg-primary rounded-full"
                style={{ height: `${value}px` }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;